<template>
  <router-link :to="{ name: 'view-best-practice-topic', params: { bestPracticeTopicId: bestPracticeTopic.sys.id } }">
    <div class="card">
      <div class="card-image">
        <figure class="image">
          <img v-if="bestPracticeTopic.fields.icon" :src="bestPracticeTopic.fields.icon.fields.file.url" :alt="bestPracticeTopic.fields.icon.fields.title">
        </figure>
      </div>
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <div class="columns">
              <div class="column is-9-desktop">
                <p class="title breakable">{{ bestPracticeTopic.fields.title }}</p>
              </div>
              <div class="column is-3-desktop">
                <div v-if="allBestPracticeCount()">
                  <p class="subtitle is-pulled-right">
                    {{ allBestPracticeCount() }} db
                  </p>
                </div>
                <div v-else>
                  <p class="subtitle is-pulled-right tooltip" data-tooltip="Fejlesztés alatt">
                    <font-awesome-icon icon="hourglass-half"></font-awesome-icon>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
  export default {
    props: [
      'bestPracticeTopic',
      'colorSelector'
    ],
    data () {
      return {
        allBestPracticeCount: function () {
          let bestPracticeCount = (this.bestPracticeTopic.fields.bestPractices || []).filter((item) => {
            return ((item.sys || {}).type === 'Entry')
          }).length
          let generalBestPracticeCount = (this.bestPracticeTopic.fields.generalBestPractices || []).filter((item) => {
            return ((item.sys || {}).type === 'Entry')
          }).length

          return bestPracticeCount + generalBestPracticeCount
        }
      }
    }
  }
</script>

<style scoped>
  .card {
    border: 0;
  }
  .breakable {
    word-break: normal;
  }
  .title {
    font-size: 1.1rem;
  }
  .subtitle {
    font-size: 1.1rem;
  }
  .card-content {
    padding: .5rem 1rem;
  }
</style>




// WEBPACK FOOTER //
// src/components/BestPractice/TopicCard.vue